<template>

<div class="container main-content">
	
	<div class="row">

		<div class="col-md-1 offset-0 offset-md-2 col-12 pb-md-0 pb-3 header-container text-center">
			<div class="stopwatch" alt="Stopwatch"></div>
		</div>
		
		<div class="col-md-6 col-12 header-container text-center">
			<h2 class="lrg primary-highlight">Please go to your local branch with valid ID to complete your payment</h2>
		</div>
	</div>

	<div class="row">
		<div class="col-12 col-md-8 offset-md-2 text-center">
			<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
		</div>
	</div>

	<div class="row mt-2 mb-3">
		<div class="col-12 offset-0 col-md-6 offset-md-3 text-center alert alert-timer">
			<small>Your Reference Number</small>
			<h1>{{ $gstate.getRefId() }}</h1>
		</div>
	</div>

	<div class="row mb-5">
		<div class="offset-0 col-12 offset-sm-2 col-sm-8 text-center info-text">			
				<p>
				1.  Inform the teller you are making a payment to Coincurve.<br />
				2.  Present your <strong>Reference Number</strong> and <strong>Valid ID</strong>
				</p>
			<small>We have sent your Reference Number to your email.  Payment must be received within 12 hours or this transaction will expire.</small>
		</div>
	</div>

	<div class="row mb-4">
		<div class="col-12">
			<google-map />
		</div>
	</div>

	<div class="row mb-4">

		<div class="col-12">
			<div class="id-block">
				
				<div class="col-12 pl-4 pr-4 pt-4">
					<div class="pt-1 pb-4 id-block-header">
						<h3 class="mb-0">Valid ID</h3>
					</div>
				</div> 
				
				<div class="row  pr-3 pb-3 pl-3">
					<div class="col-4 pt-4 pr-0 pb-4 pl-4">
						<img src="./../assets/img/id.png" class="img-fluid float-left">
					</div>
					<div class="col-8 pt-4 pr-4 pb-4 pl-0">
						<ul>
							<li>Passport</li>
							<li>Driver’s license</li>
							<li>Professional Regulations Commission (PRC) ID</li>
							<li>Integrated Bar of the Philippines (IBP) ID</li>
							<li>National Bureau of Investigation (NBI) clearance</li>
							<li>Police Clearance Certificate (Electronic)</li>
							<li>Postal ID</li>
							<li>Voter’s ID</li>
							<li>Tax Identification Number ID</li>
							<li>Barangay Certification</li>
							<li>Government Service and Insurance System (GSIS) e-Card</li>
							<li>Social Security System (SSS) card</li>
							<li>Senior Citizen Card</li>
							<li>Overseas Workers Welfare Administration (OWWA) ID</li>
							<li>OFW ID</li>
							<li>Seaman’s Book</li>
							<li>Alien Certification of Registration/Immigrant Certificate of Registration</li>
							<li>Firearm license</li>
							<li>Employment ID (Government and Private)</li>
							<li>Student ID (for non-voting/minor age students)</li>
							<li>Other IDs issued by the Government and its Instrumentalities (Digitized hard plastic Type)</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
   
	<div class="row mt-5 btn-rounded-height">
		<div class="col-12 col-sm-10 offset-sm-1">
			<a href="#" id="payment-etransfer-next" class="btn next-btn" v-on:click.prevent="done">Next</a>
		</div>
	</div>

	<cc-modal v-if="showConfirmModal" v-bind:confirm="true" @action="actionModal">
		<h3 slot="header">Confirm</h3>
		<p slot="body">Did you note down your Reference Number?</p>
	</cc-modal>
</div>

</template>

<script>
import GoogleMap from '@/components/GoogleMap'
export default {
	components: {
		GoogleMap
	},
	data() {
		return {
			showConfirmModal: false
		}
	},
	created(){
		this.$emit('setRateHoldTimer', false);
	},
	methods: {
		done: function() {
			this.showConfirmModal = true; 
		},
		actionModal: function(action){
			
			this.showConfirmModal = false;
			
			if(action == "yes"){
				this.$router.push("payment-otc-success");
			}
		}, 
		onCopy(e){
			this.$toasted.info("Copied " + e.text);
		},
		onCopyError(){
			this.$toasted.error("Error copying.  Try copying manually.");
		}
	}
}
</script>
